import {NavigationError} from '@angular/router';
import {NotFoundError} from 'app/core/components/error-page/order-history-error';

export const navigationErrorHandler = (error: NavigationError) => {
  throw new NotFoundError(error.error);
};
